export default "__VITE_ASSET__xUGWxxAQ__"